import { useHasPermission } from '@versita/frontend/auth-web';
import { ButtonStyle, LinkButton } from '@versita/frontend/campus-ui-web';
import { Actions } from '@versita/shared/models';

export const AdminNav = () => {
  const canEdit = useHasPermission(Actions.Timetable.Write.All);

  return (
    <>
      <LinkButton
        $buttonStyle={ButtonStyle.Secondary}
        to="/courses"
        style={{ marginRight: '1rem' }}
      >
        Search for a Course Timetable
      </LinkButton>
      {canEdit && (
        <LinkButton
          $buttonStyle={ButtonStyle.Secondary}
          style={{ marginRight: '1rem' }}
          to="/admin/timetable/course"
        >
          Manage Course Timetables
        </LinkButton>
      )}
      {canEdit && (
        <LinkButton
          $buttonStyle={ButtonStyle.Secondary}
          to="/admin/timetable/student"
        >
          Manage Student Timetables
        </LinkButton>
      )}
    </>
  );
};

export default AdminNav;
